import type { ActivityDTO } from './activity.dto';
import type { AppointmentDTO } from './appointment.dto';
import type { InspectorDTO } from './inspector.dto';

export type RescheduleProgressStatus =
  | 'pending'
  | 'in_progress'
  | 'completed'
  | 'failed'
  | 'cancelled';

export type RescheduleProgressType =
  | 'auditor_cancelled'
  | 'customer_cancelled'
  | 'other';

export interface RescheduleProgressAllocatedInspectorDTO {
  id?: number;
  inspector?: InspectorDTO;
  travelDistance?: number;
  slot?: InspectorDTO['slots'];
  solutionAppointments?: InspectorDTO['solutionAppointments'];
}

export interface RescheduleProgressChangeDTO {
  solutionId: number;
  activity: ActivityDTO;
  oldAppointments: AppointmentDTO[];
  newAllocatedInspectors: RescheduleProgressAllocatedInspectorDTO[];
}

export interface RescheduleProgressDTO {
  id: number;
  type: RescheduleProgressType;
  status: RescheduleProgressStatus;
  total: number;
  completed: number;
  failed: number;
  succeeded: number;
  notes: string | null;
  isActive?: boolean;
  changes?: RescheduleProgressChangeDTO[];
}

export const isRescheduleProgressTerminal = (status: RescheduleProgressStatus) =>
  status === 'completed' || status === 'failed' || status === 'cancelled';

export const isRescheduleProgressRunning = (status: RescheduleProgressStatus) =>
  status === 'in_progress' || status === 'pending';
